export default __webpack_public_path__ + "static/media/roadmap.08f687e8.png";